import axios from "axios";

const ShopifyGetPatches = async (ids) => {
  const mapped = ids.map((id) => `(id:${id.replace("gid://shopify/Product/", "")})`);
  const joined = mapped.join(" OR ");
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `{
          products(first:${ids.length}, query:"${joined}") {
            edges {
              node {
                id
                title
                featuredImage {
                  url(transform: {maxHeight: 500})
                }
                points: metafield(key:"patch_points", namespace:"my_fields") {
                  value
                }
                width: metafield(key:"patch_width", namespace:"my_fields") {
                  value
                }
                height: metafield(key:"patch_height", namespace:"my_fields") {
                  value
                }
                material: metafield(key:"patch_material", namespace:"my_fields") {
                  value
                }
                centerback: metafield(key:"patch_centerback", namespace:"my_fields") {
                  value
                }
                totalInventory
                variants(first:1) {
                  edges {
                    node {
                      id
                    }
                  }
                }
              }
            }
          }
        }`,
      },
    });
    if (response.data.body.data.products) {
      const { products } = response.data.body.data;
      return products.edges
        .filter((e) => !!e.node.points && !!e.node.width && !!e.node.height)
        .map((patch) => ({
          id: patch.node.id,
          vid: patch.node.variants.edges[0].node.id,
          title: patch.node.title,
          src: patch.node.featuredImage ? patch.node.featuredImage.url : "",
          points: parseInt(patch.node.points.value),
          width: JSON.parse(patch.node.width.value).value,
          height: JSON.parse(patch.node.height.value).value,
          material: patch.node.material ? patch.node.material.value : "",
          centerback: patch.node.centerback ? patch.node.centerback.value === "true" : false,
          inventory: patch.node.totalInventory,
        }));
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetPatches;
